import { SummarizeClickProps } from '../../types/optimizerTable';
export const handleSummarizeClick = async ({
  optimizeData,
  setIsSummarizeLoading,
  navigate,
}: SummarizeClickProps) => {
  try {
    setIsSummarizeLoading(true);
    const selectedOptionsGroupedByTitle = optimizeData.reduce(
      (
        acc,
        { title, averagePrice, optimizationOptions },
      ) => {
        const filteredOptions = optimizationOptions?.filter(
          ({ enabled, isChat, optCostsResults }) =>
            (enabled === true ||
              (enabled === false &&
                optCostsResults !== undefined)) &&
            isChat === 'search',
        );
        if (filteredOptions && filteredOptions.length > 0) {
          acc.push({
            title,
            averagePrice,
            optimizationOptions: filteredOptions.map(
              ({ id, title, isChat, optCostsResults }) => ({
                id,
                title,
                isChat,
                optCostsResults: optCostsResults?.filter(
                  ({ enabled }) => enabled,
                ),
              }),
            ),
          });
        }
        return acc;
      },
      [] as Array<{
        title: string;
        averagePrice: number;
        optimizationOptions: Array<unknown>;
      }>,
    );
    localStorage.setItem(
      'selectedOptions',
      JSON.stringify(selectedOptionsGroupedByTitle),
    );
    navigate('/summarize');
  } catch (error) {
    console.error(error);
  } finally {
    setIsSummarizeLoading(false);
  }
};
